import { formatCurrency as sharedFormatCurrency } from '@shared';

interface ReadOnlyContentProps {
  accountLabel: string;
  isIncomeStream: boolean;
  source: SelfFundingSource | undefined;
}

/**
 * Read-only grid view shown to recipients of a partner-shared self-funding
 * source. Uses the same gray-boxed layout as the guided-planning locked card.
 */
export function ReadOnlyContent({ accountLabel, isIncomeStream, source }: ReadOnlyContentProps) {
  return (
    <div className="grid grid-cols-2 gap-3">
      <div className="bg-muted col-span-2 rounded-lg p-2.5">
        <p className="text-foreground text-xs font-medium">Account Type</p>
        <p className="mt-0.5 text-sm font-semibold text-gray-950">{accountLabel}</p>
      </div>
      <div className="bg-muted rounded-lg p-2.5">
        <p className="text-foreground text-xs font-medium">
          {isIncomeStream ? 'Annual Income' : 'Current Balance'}
        </p>
        <p className="mt-0.5 text-sm font-semibold text-gray-950">
          {source?.existingAssetsValue != null
            ? sharedFormatCurrency(source.existingAssetsValue, 0)
            : '—'}
        </p>
      </div>
      {!isIncomeStream && (
        <div className="bg-muted rounded-lg p-2.5">
          <p className="text-foreground text-xs font-medium">Yearly Contribution</p>
          <p className="mt-0.5 text-sm font-semibold text-gray-950">
            {source?.monthlyContributionAmount != null
              ? sharedFormatCurrency(source.monthlyContributionAmount * 12, 0)
              : '—'}
          </p>
        </div>
      )}
      <div className="bg-muted rounded-lg p-2.5">
        <p className="text-foreground text-xs font-medium">
          {isIncomeStream ? 'Expected Annual Growth' : 'Annual Rate of Return'}
        </p>
        <p className="mt-0.5 text-sm font-semibold text-gray-950">
          {source?.annualRateOfReturn != null
            ? `${Math.round(source.annualRateOfReturn * 100)}%`
            : '—'}
        </p>
      </div>
      <div className="bg-muted rounded-lg p-2.5">
        <p className="text-foreground text-xs font-medium">Tax Rate</p>
        <p className="mt-0.5 text-sm font-semibold text-gray-950">
          {source?.gainsTaxRate != null ? `${Math.round(source.gainsTaxRate * 100)}%` : '—'}
        </p>
      </div>
    </div>
  );
}
